import { ref } from 'vue'
import { http } from '../utils/index'

export function useGetForm({ formModel, formUrl, formParam, getFormDataAfter, formMethod }) {
  const formData = ref(null)

  const getFormData = async () => {
    if (formUrl.value) {
      const [resData] = await http[formMethod.value ?? 'get'](
        formUrl.value,
        typeof formParam.value == 'function' ? formParam.value() : formParam.value
      )
      const tempData = resData?.data ?? formData.value
      formData.value = (await getFormDataAfter.value?.(tempData)) ?? tempData
    } else {
      formData.value = { ...formModel.value }
    }
  }
  return {
    setFormData(data) {
      formData.value = data
    },
    formData,
    getFormData,
  }
}
